import { CELLARHOST_URL, STATIC_SERVICE_PATHS } from "@/lib/external-links";

/** Public offer lock. Prices only from playbooks / live SKU pages. */

export const ideas = [
    {
        title: "Founder-led",
        body: "William takes the diagnostic. You are not passed to a bench we don't have.",
    },
    {
        title: "Fixed pricing",
        body: "Published SKUs have a number. Custom work gets a fixed proposal after the diagnostic — not a vague hourly.",
    },
    {
        title: "You own it",
        body: "Sites, data, accounts, and the code we ship for you. We don't keep the keys.",
    },
    {
        title: "No long contracts",
        body: "Care and recovery are month-to-month after the pilot or setup. Leave when it stops earning its keep.",
    },
    {
        title: "Production-ready",
        body: "Shipped systems, not 90-slide decks. If it isn't live, we don't pretend it is.",
    },
];

export const services = [
    {
        slug: "websites",
        icon: "Globe",
        title: "Websites",
        short: "Conversion-first sites. $199 one-pager or a custom build.",
        href: "/websites",
        price: "$199 CAD",
        cta: "Get the $199 site",
        features: [
            "One custom page, your branding, mobile-friendly",
            "Click-to-call, contact, maps, social",
            "One revision, launch help",
            "24–48 hours after we have the assets",
        ],
        deliverables: ["Live one-page site", "Your copy and photos on it", "Handoff of the files"],
        process: "Pay $199 → intake → we build → you review → go live.",
        limits: "Not in $199: extra pages, booking, Google Business Profile, care, custom apps, domain fees.",
        faq: [
            { q: "Is it really $199?", a: "Yes. $199 CAD upfront before build. Upgrades are separate and listed." },
        ],
    },
    {
        slug: "chatbots",
        icon: "MessageSquare",
        title: "Chat & lead capture",
        short: "Askbox on the site you already have. Answers FAQs and hands off the next step.",
        href: "/askbox",
        price: "$1,197 CAD setup",
        cta: "Get Askbox",
        features: [
            "Widget trained on your existing pages",
            "Book / buy / leave-a-number buttons",
            "Live in 72 hours from a complete brief",
            "7-day tweak window after launch",
        ],
        deliverables: ["Embed snippet", "Answer brain from your site", "Optional keep-alive"],
        process: "Send the URL → we build the brain → you paste one snippet.",
        limits: "Keep-alive is optional at $297 CAD/month. Not a full custom agent.",
        faq: [
            {
                q: "What is keep-alive?",
                a: "$297 CAD/month for hosting, a monthly refresh, and ongoing tweaks. Setup works without it.",
            },
        ],
    },
    {
        slug: "crm",
        icon: "Workflow",
        title: "CRM automation",
        short: "Follow-up, sync, and missed-lead routing so nothing dies in the inbox.",
        href: "/pricing",
        price: "After diagnostic",
        cta: "Book the diagnostic",
        features: [
            "Lead routing from missed and after-hours capture",
            "CRM sync and follow-up sequences",
            "Works with HubSpot, Salesforce, Pipedrive, Close, and anything with an API",
        ],
        deliverables: ["Mapped leak", "Fixed proposal", "Wired workflows"],
        process: "Diagnostic → proposal → we build the loops.",
        limits: "Not a one-click CRM admin retainer. Scope is the leak we find.",
        faq: [],
    },
    {
        slug: "workflows",
        icon: "Repeat",
        title: "Workflow automation",
        short: "Repeatable sales and ops loops. The busywork leaves. Closing stays.",
        href: "/pricing",
        price: "After diagnostic",
        cta: "Book the diagnostic",
        features: [
            "Intake to follow-up without a human copying fields",
            "Handoffs between capture, CRM, and calendar",
            "Only the loops that actually move revenue",
        ],
        deliverables: ["Operating map", "Automations in your tools", "Handoff notes"],
        process: "Diagnostic → which loops pay → we ship those first.",
        limits: "We don't boil the ocean. First loops are the leak.",
        faq: [],
    },
    {
        slug: "voice",
        icon: "Phone",
        title: "Voice & missed-call recovery",
        short: "After-hours and missed calls recovered, then proven on a 14-day HVAC pilot.",
        href: STATIC_SERVICE_PATHS.hvacRecovery,
        price: "$500 setup + $500/month",
        cta: "HVAC Recovery",
        features: [
            "14-day missed revenue recovery pilot",
            "Independent HVAC, Niagara–Hamilton corridor first",
            "You see what was recovered",
        ],
        deliverables: ["Pilot live", "Day-14 report", "Month-to-month after if it pays"],
        process: "10-minute fit call → $500 setup → 14 days → keep or leave.",
        limits: "Pilot is HVAC. Other verticals are custom after diagnostic.",
        faq: [],
    },
    {
        slug: "agents",
        icon: "Bot",
        title: "Custom AI agents",
        short: "Copilots trained on your knowledge. CellarHost is the sister proof for wineries.",
        href: CELLARHOST_URL,
        price: "From $499/month",
        cta: "See CellarHost",
        features: [
            "Trained on your material, not a generic bot",
            "Handoff to a human when it should",
            "CellarHost: concierge for premium estates, from $499/month",
        ],
        deliverables: ["Scoped agent or CellarHost install", "Quoted implementation"],
        process: "Winery walkthrough for CellarHost. Anything else starts at the diagnostic.",
        limits: "CellarHost is a sister product. No fake 24/7 SLA. Aurelia demo is fictional.",
        faq: [],
    },
    {
        slug: "audit",
        icon: "ClipboardCheck",
        title: "Diagnostic & strategy",
        short: "Thirty minutes. The leak and a price — whether you hire us or not.",
        href: "/#contact",
        price: "Free",
        cta: "Book the diagnostic",
        features: [
            "Pipeline and capture audit",
            "Named bottleneck",
            "Fixed price if we should keep going",
        ],
        deliverables: ["The leak", "A number", "A yes/no"],
        process: "Book → 30 minutes → you leave with the map.",
        limits: "Not a 90-slide workshop. Not a discovery that you pay for.",
        faq: [{ q: "Is it really free?", a: "Yes. Zero commitment." }],
    },
];

export const pricingTabs = [
    {
        id: "offers",
        label: "Offers",
        blurb: "What you can buy today. Numbers from the live SKUs — not a made-up Starter ladder.",
    },
    {
        id: "care",
        label: "Care",
        blurb: "Month-to-month after setup. Ad budget is never mixed into our fee.",
    },
    {
        id: "custom",
        label: "Custom",
        blurb: "If it isn't a SKU, it goes through the diagnostic and comes back as a fixed proposal.",
    },
];

export const offerTiers = [
    {
        name: "Starter",
        sku: "$199 Website",
        price: "$199",
        cadence: "CAD, upfront",
        href: "/websites",
        cta: "Get the site",
        highlight: false,
        points: [
            "One custom page, 24–48 hours",
            "Your branding and click-to-call",
            "Pay first — not a workshop",
        ],
    },
    {
        name: "Capture",
        sku: "Askbox",
        price: "$1,197",
        cadence: "CAD setup",
        href: "/askbox",
        cta: "Get Askbox",
        highlight: false,
        points: [
            "On the site you already have",
            "72-hour build",
            "Optional keep-alive $297/month",
        ],
    },
    {
        name: "Recovery",
        sku: "HVAC Recovery",
        price: "$500",
        cadence: "+ $500/month after the 14-day pilot",
        href: STATIC_SERVICE_PATHS.hvacRecovery,
        cta: "Fit call",
        highlight: true,
        points: [
            "Missed and after-hours HVAC calls",
            "10-minute fit call",
            "Month-to-month after the pilot",
        ],
    },
    {
        name: "Partner",
        sku: "Custom revenue system",
        price: "Diagnostic",
        cadence: "then a fixed proposal",
        href: "/#contact",
        cta: "Book the diagnostic",
        highlight: false,
        points: [
            "Thirty minutes, free",
            "You leave with the leak and a price",
            "You own the work",
        ],
    },
];

export const carePlans = [
    {
        name: "Website care",
        price: "from $29/month",
        href: "/websites",
        points: ["Updates and changes on a $199 site", "Month-to-month"],
    },
    {
        name: "Askbox keep-alive",
        price: "$297/month",
        href: "/askbox",
        points: ["Hosting, monthly refresh, tweaks", "Optional — setup works without it"],
    },
    {
        name: "HVAC Recovery",
        price: "$500/month",
        href: STATIC_SERVICE_PATHS.hvacRecovery,
        points: ["After the $500 / 14-day pilot", "Cancel when it stops paying"],
    },
    {
        name: "CellarHost",
        price: "from $499/month",
        href: CELLARHOST_URL,
        points: ["Winery concierge, implementation quoted", "Sister product"],
    },
];

export const products = [
    {
        name: "$199 Website",
        status: "Live",
        href: "/websites",
        problem: "Local businesses with no site, or a site that doesn't convert.",
        note: "Demo sites on that page are fictional.",
    },
    {
        name: "Askbox",
        status: "Live",
        href: "/askbox",
        problem: "An existing site that doesn't capture or answer after hours.",
        note: "Physio demo is fictional.",
    },
    {
        name: "HVAC Recovery",
        status: "Live",
        href: STATIC_SERVICE_PATHS.hvacRecovery,
        problem: "Independent HVAC shops losing missed and after-hours calls.",
        note: "Demo is synthetic.",
    },
    {
        name: "CellarHost",
        status: "Live · sister",
        href: CELLARHOST_URL,
        problem: "Premium estates that need a concierge, not a chatbot.",
        note: "Aurelia is fictional.",
    },
];

export const extras = [
    { name: "Additional website pages", price: "from $49/page" },
    { name: "Booking integration", price: "from $49" },
    { name: "Google Business Profile help", price: "from $49" },
];

export const costDrivers = [
    "How many systems we have to touch",
    "Integrations — CRM, calendar, phone, ads",
    "Voice or agent coverage hours",
    "Content we write vs what you already have",
    "Whether a live SKU already solves it",
];

export const navServices = [
    {
        label: "All services",
        description: "Seven lines. Real SKUs and custom.",
        href: "/services",
        kind: "app",
    },
    ...services.map((s) => ({
        label: s.title,
        description: s.short,
        href: `/services?tab=${s.slug}`,
        kind: "app",
    })),
];

export const companyPaths = ["/", "/pricing", "/services", "/products"];
